import type { MouseEvent } from 'react';

/** Use the page's contact band, or the homepage band when none is present. */
export function scrollToContactBand(event: MouseEvent<HTMLAnchorElement>) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopPropagation();
  const band = document.getElementById('kontakt-aufnehmen') ?? document.getElementById('kontakt-band');
  if (band) {
    band.scrollIntoView({
      block: 'start',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  } else {
    window.location.assign(event.currentTarget.href);
  }
}
